import {ButtonPrimary, ButtonSecondary, CsvFileIcon, NextIcon, UploadFileIcon} from '@modifi/ui'

import {StyledButtonLink, StyledButtonLight} from './styles'

export const ctaMapping: Record<string, any> = {
  primary: ButtonPrimary,
  secondary: ButtonSecondary,
  link: StyledButtonLink,
  // @todo to use default one once button package is upgraded
  light: StyledButtonLight,
}

export const iconMapping: Record<string, any> = {
  next: NextIcon,
  upload: UploadFileIcon,
  download: CsvFileIcon,
}
